export default __webpack_public_path__ + "static/media/aboutUsMockup.d2a06e52.jpg";